// extracted by mini-css-extract-plugin
export default {"options":"TranslatePlaceholder_options__LgKgO","hide":"TranslatePlaceholder_hide__cJS2W"};